var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconInfoCircle = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.4706 22 22 17.4706 22 12C22 6.53922 17.4608 2 11.9902 2C6.52941 2 2 6.53922 2 12C2 17.4706 6.53922 22 12 22ZM11.9118 8.5098C11.2059 8.5098 10.6373 7.94118 10.6373 7.23529C10.6373 6.51961 11.2059 5.95098 11.9118 5.95098C12.6275 5.95098 13.1863 6.51961 13.1863 7.23529C13.1863 7.94118 12.6275 8.5098 11.9118 8.5098ZM10.2843 17.3922C9.88235 17.3922 9.56863 17.1078 9.56863 16.7059C9.56863 16.3235 9.88235 16.0196 10.2843 16.0196H11.5V11.5196H10.451C10.049 11.5196 9.73529 11.2353 9.73529 10.8333C9.73529 10.451 10.049 10.1471 10.451 10.1471H12.2941C12.7941 10.1471 13.0588 10.5 13.0588 11.0294V16.0196H14.2745C14.6765 16.0196 14.9902 16.3235 14.9902 16.7059C14.9902 17.1078 14.6765 17.3922 14.2745 17.3922H10.2843Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconInfoCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-info-circle.50e97205cf7daabc45eadbe159052d5a.svg";